import React from 'react';
import { Navigate } from 'react-router-dom';

const AdminProtectedRoute = ({ children }) => {
    const isAdminAuthenticated = !!localStorage.getItem('adminId');

    if (!isAdminAuthenticated) {
        // Redirect to admin login if not authenticated
        return <Navigate to="/admin/login" replace />;
    }

    // Render children if authenticated
    return children;
};

export default AdminProtectedRoute;
